import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CardState, openHorizontalSimple} from '../../../animations';
import {debounceTime} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
  selector: 'as-filter-shelf',
  templateUrl: './filter-shelf.component.html',
  styleUrls: ['../../../styles/container.scss', './filter-shelf.component.scss'],
  animations: [openHorizontalSimple]
})
export class FilterShelfComponent implements OnInit {

  @Input() data;
  @Input() dataSubscriber;
  @Input() filterDataSubscriber;
  @Input() clickPath;
  @Input() exclude;
  @Input() search: boolean = true;
  @Input() customFilterFields: boolean = false;
  @Input() isTypeahead: boolean = true;
  @Input() isFilter: boolean = true;
  @Input() filterOnKeys = [];

  @ViewChild('typeahead', {static: false}) typeahead;
  @ViewChild('filterItem', {static: false}) filterItem;

  @Output() searchFilteredTerm = new EventEmitter();
  @Output() filteredDataEmitter = new EventEmitter();
  @Output() currentSearchFieldTerm = new EventEmitter();
  @Output() filterOn = new EventEmitter();

  isFilterEngaged: boolean; //filters have value
  isFilterOpened: CardState = CardState.Closed; //shelf is opened
  filterHeaders = [];
  filterItems = [];
  checkedItems = [];
  filteredData = [];
  timeout = 1200;
  filterChanged = new Subject<string>();
  filterEngaged: boolean = false;

  constructor() {
    this.filterChanged.pipe(debounceTime(this.timeout)).subscribe((d) => {
      this.processFilters(d)
    })
  }

  ngOnInit() {

    if (!this.customFilterFields) {

      this.filterDataSubscriber.subscribe((filters) => {

        //note: filters come in this Object form:
        //    {
        //       sent: {type: "dropdown",data: [
        //           {name: "Both", id : 0, networkId :0}
        //         ]},
        //     }
        for (let [k, v] of Object.entries(filters)) {
          this.filterHeaders.push(k);
          this.filterItems.push(v)
        }
      })

    }
  
      this.dataSubscriber.subscribe((d) => {
        this.data = d;
        if (this.typeahead != undefined) {
          this.typeahead.setData(d);
        }
      });
  }

  toggleFilter() {
    this.isFilter = !this.isFilter;
    this.setFilterVisibility((this.isFilterOpened == CardState.Open) ? CardState.Closed : CardState.Open)
    this.isFilterOpened = this.getFilterVisibility();

  }

  handleTypeaheadOutput(event) {
    this.searchFilteredTerm.emit(event)
  }

  setCurrentSearchTerm(event) {
    this.currentSearchFieldTerm.emit(event)
  }

  handleFilterOutput(event) {
    //debounce

    this.filterOn.emit(event)
    this.filterChanged.next(event);
  }

  processFilters(event) {

    this.filteredData = [];
    let checkedValues = [];//we need to reset these every time
    let checkedKeys = [];
    let setANDonKey = '';

    //this.checkedItems accumulate items to filter

    event.forEach((e) => {
      if (e.checked == true && !this.checkedItems.includes(e)) {
        this.checkedItems.push(e);
      }

      if (e.checked == false || e.checked == undefined) {
        this.checkedItems.forEach((c, inx) => {
          if (c.checked == false || c.checked == undefined) {
            this.checkedItems.splice(inx, 1)
          }
        })
      }
    })

    this.checkedItems.forEach((c) => {

      checkedValues.push(c.value);
      checkedKeys.push(c.key);

      if (checkedKeys.includes(c.key)) {
        setANDonKey = c.key;
      }

      // match filters with value
      this.data.map((e) => {
        //value is an additional parameter in case the header and name is different.
        if ((c.name && e[c.key] == c.name) || (c.value && e[c.key] == c.value)) {

          if (!this.filteredData.includes(e)) {
            this.filteredData.push(e);
          }
        }
      });

    })

    let filteredFilteredData = [];
    //narrowing down the filtered data based on filters applied (&&)

    // this.filteredData.forEach((data) => {
    //   let accum = 0;
    //   checkedKeys.forEach((k, i) => {
    //
    //     if (data[k] == checkedValues[i]) {
    //       accum++;
    //
    //       if (k == setANDonKey) {
    //         filteredFilteredData.push(data)
    //       }
    //       if (accum == checkedValues.length ) {
    //         filteredFilteredData.push(data)
    //       }
    //
    //     }
    //   })
    // })

    this.isFilterEngaged = true;
    this.filteredDataEmitter.emit(this.filteredData)

    if (this.checkedItems.length == 0) {
      this.filteredDataEmitter.emit("reset-filter-data");
      this.isFilterEngaged = false;
    }

  }

  setFilterVisibility(value: CardState) {
    this.isFilterOpened = value;
  }

  getFilterVisibility(): CardState {
    return this.isFilterOpened;
  }

  public clearFilter() {
    this.isFilterEngaged = false;
    this.typeahead.clearResults();
    this.typeahead.clearSearch();
  }

  excludeFilter(item) {
    return !this.exclude.includes(item)
  }

  updateData(event: any, filter: string) {

    if (filter == "clear") {
      event = [];
    }
    this.filteredDataEmitter.emit(event)
  }
}
